import Skeleton from "react-loading-skeleton";

import MetricCard from "components/MetricCard";
import MissingDataBanner from "components/MissingDataBanner";
import Box from "ds/components/Box";
import useTypedContext from "hooks/useTypedContext";

import { StacksRequiringAttentionContext } from "./context";
import DashboardWidgetsStacksRequiringAttentionEmpty from "./components/Empty";
import DashboardWidgetsStacksRequiringAttentionMigratedCallout from "./components/MigratedCallout";
import DashboardWidgetsStacksRequiringAttentionReadyToMigrateCallout from "./components/ReadyToMigrateCallout";
import useStacksRequiringAttentionActions from "./useStacksRequiringAttentionActions";

const DashboardWidgetsStacksRequiringAttention = () => {
  const { readyToMigrate, migrated, isLoading, isEmpty, error, refetch } = useTypedContext(
    StacksRequiringAttentionContext
  );

  const { handleMigrateAll, handleRollbackAll, migrateLoading, rollbackLoading } =
    useStacksRequiringAttentionActions();

  if (error) {
    return (
      <MissingDataBanner
        text="Couldn't load stacks data. Please try to refresh or come back later."
        refreshHandler={refetch}
        fullWidth
      />
    );
  }

  if (isEmpty) {
    return <DashboardWidgetsStacksRequiringAttentionEmpty />;
  }

  return (
    <Box direction="column" gap="large" fullWidth>
      {!isLoading && readyToMigrate > 0 && (
        <DashboardWidgetsStacksRequiringAttentionReadyToMigrateCallout
          onMigrate={handleMigrateAll}
          migrateLoading={migrateLoading}
          disabled={rollbackLoading}
        />
      )}
      {!isLoading && migrated > 0 && (
        <DashboardWidgetsStacksRequiringAttentionMigratedCallout
          migrated={migrated}
          onRollback={handleRollbackAll}
          migrateLoading={migrateLoading}
          rollbackLoading={rollbackLoading}
          showMigrationGuideLink={readyToMigrate === 0}
        />
      )}

      <Box gap="large" fullWidth>
        <MetricCard
          grow="1"
          titleColor="primary"
          title="Ready to migrate"
          value={isLoading ? <Skeleton width={40} height={32} /> : readyToMigrate}
        />
        <MetricCard
          grow="1"
          titleColor="primary"
          title="Migrated"
          value={isLoading ? <Skeleton width={40} height={32} /> : migrated}
        />
      </Box>
    </Box>
  );
};

export default DashboardWidgetsStacksRequiringAttention;
